import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "./styles.css";

const range = (from, to) => {
  const lastIndex = to + 1;
  const length = lastIndex - from;
  return _Array$from({
    length
  }, (_, i) => from + i);
};

const getPlaceholderElementCount = (numberOfChildren, maxColumnCount) => {
  var _context;

  const maxElementsNeeded = _reduceInstanceProperty(_context = range(1, maxColumnCount)).call(_context, (max, columnCount) => {
    let numberOfElementsNeeded = numberOfChildren;

    while (numberOfElementsNeeded % columnCount !== 0) {
      numberOfElementsNeeded += 1;
    }

    return Math.max(max, numberOfElementsNeeded);
  }, 0);

  return maxElementsNeeded - numberOfChildren;
};

const Grid = props => {
  var _context2;

  const {
    maxColumnCount,
    gutter,
    maxCardWidth,
    minCardWidth,
    children,
    classes: classesProp,
    placeholderAs: Placeholder,
    ...rest
  } = props;
  const classes = useClasses(styles, classesProp);
  const flexBasis = `calc((100% / ${maxColumnCount}) - ${gutter}px)`;
  const halfGutter = `calc(${gutter}px / 2)`;
  const gridWidth = `calc(${maxColumnCount} * ${maxCardWidth}px + ${gutter}px)`;
  const baseCardStyles = {
    flexBasis,
    marginLeft: halfGutter,
    marginRight: halfGutter,
    maxWidth: `${maxCardWidth}px`,
    minWidth: `${minCardWidth}px`
  };

  const renderChildMapper = (child, index) => /*#__PURE__*/React.createElement("div", {
    className: classes.card,
    key: `child-${index}`,
    style: { ...baseCardStyles,
      marginBottom: `${gutter}px`
    }
  }, child);

  const renderPlaceholderElementMapper = (_, index) => /*#__PURE__*/React.createElement(Placeholder, {
    className: classes.card,
    style: baseCardStyles,
    key: `placeholder-${index}`
  });

  const placeholderElements = _Array$from({
    length: getPlaceholderElementCount(React.Children.count(children), maxColumnCount)
  }, renderPlaceholderElementMapper);

  const gridStyles = {
    marginLeft: `-${halfGutter}`,
    marginRight: `-${halfGutter}`,
    maxWidth: gridWidth,
    width: gridWidth
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classes.grid,
    style: gridStyles
  }, rest), _mapInstanceProperty(_context2 = React.Children).call(_context2, children, renderChildMapper), placeholderElements));
};

process.env.NODE_ENV !== "production" ? Grid.propTypes = {
  /**
   * Space to reserve between children
   */
  gutter: PropTypes.number.isRequired,

  /**
   * Max width of cards
   */
  maxCardWidth: PropTypes.number.isRequired,

  /**
   * Min width of cards
   */
  minCardWidth: PropTypes.number.isRequired,

  /**
   * Grid items. Each will be wrapped in a div element
   */
  children: PropTypes.node.isRequired,

  /**
   * Class dependencies
   */
  classes: classesPropType(['card', 'grid']),

  /**
   * Maximum number of columns allowed
   */
  maxColumnCount: PropTypes.number.isRequired,

  /**
   * Element or component reference to change how placeholders are rendered
   */
  placeholderAs: PropTypes.elementType
} : void 0;
Grid.defaultProps = {
  placeholderAs: 'div'
};
export default Grid;